import script from "./JornadaSection.vue?vue&type=script&setup=true&lang=js"
export * from "./JornadaSection.vue?vue&type=script&setup=true&lang=js"

import "./JornadaSection.vue?vue&type=style&index=0&id=516edf9f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-516edf9f"]])

export default __exports__